import styled from "styled-components";
import { Link as LinkR } from 'react-router-dom';

export const InfoContainer = styled.section`
    color:#fff;
    background: ${({lightBg}) => (lightBg ? '#111221' : '#111221')};
    @media screen and (max-width:768px){
        padding:100px 0;
    }
    @media screen and (max-width:500px){
        padding:1rem 0;
    }
`;

export const InfoWrapper = styled.div`
    display:grid;
    z-index:1;
    height:40rem;
    width:100%;
    max-width:1200px;
    margin-right:auto;
    margin-left:auto;
    justify-content:center;
    @media screen and (max-width:868px){
        height:auto !important;
        padding:0 10px;
    }
    @media screen and (max-width:500px){
        height:auto !important;
        padding:0 0px;
    }
`;

export const InfoRow = styled.div`
    display:grid;
    grid-auto-columns: minmax(auto, 1fr);
    align-items:center;
    grid-template-areas: ${({imgStart}) => (imgStart ? `'col2 col1'` : `'col1 col2'`)};

    @media screen and (max-width:1000px){
        grid-template-areas:${({imgStart}) => (imgStart ? `'col1' 'col2'` : `'col1 col1' 'col2 col2'`)};
    }
`;

export const Column1 = styled.div`
    margin-bottom:15px;
    padding:0 5px;
    grid-area:col1;
    @media screen and (max-width:1000px){
        padding:0 0px !important;
    }
`;
export const Column2 = styled.div`
    margin-bottom:15px;
    padding:0 5px;
    grid-area:col2;
    @media screen and (max-width:1000px){
        padding:0 0px !important;
    }
`;
export const TextWrapper = styled.div`
    max-width:540px;
    padding-top:0;
    padding-bottom:60px;
    @media screen and (max-width:860px){
        padding-top:5rem !important;
    }
    @media screen and (max-width:770px){
        padding-top:0rem !important;
    }
`;
export const TopLine = styled.h1`
    color:#fff;
    font-size:2rem;
    font-weight:inherit !important;
    margin-bottom:16px;
    @media screen and (max-width:770px){
        padding:1rem;
        font-size:2rem;
        margin-bottom:-1rem;
    }
`;
export const Heading = styled.h2`
    margin-bottom:24px;
    font-size:2.3rem;
    text-align: left;
    margin-left:-0.2rem ;
    font-weight:inherit !important;
    color: ${({lightText}) => (lightText ? '#E8175D' : '#010606')};
    @media screen and (max-width:600px){
        padding:1rem;
        font-size:2rem;
        margin-bottom:1rem;
    }
`;

export const Subtitle = styled.p`
    max-width:440px;
    margin-bottom:35px;
    font-size:18px;
    line-height:24px;
    color: ${({darkText}) => (darkText ? '#010606' : '#fff')};
    @media screen and (max-width:770px){
        padding:1rem;
        margin-top:-1rem;
        margin-bottom:1rem;
    }
`;
export const BtnWrap = styled.div`
    display:flex;
    justify-content:flex-start;
    @media screen and (max-width:770px){
        padding:1rem;
    }
`;
export const ImgWrap = styled.div`
    max-width:484px;
    height:100%;
    @media screen and (max-width:770px){
        margin-top:-2rem;
    }
`;
export const Img = styled.img`
    width:80%;
    margin:auto;
    display:block;
    object-fit:cover;
    border:2px solid #E8175D;
    padding:1.5rem;
    border-radius:10px;
    margin-left:10rem;
    @media screen and (max-width:1200px){
        margin-left:auto !important;
    }
`;
export const Button = styled(LinkR)`
    text-decoration:none;
    background: ${({primary}) => (primary ? '#E8175D' : '#010606' ) };
    white-space:nowrap;
    padding: ${({big}) => (big ? '14px 48px' : '12px 30px' )};
    color: ${({dark}) => (dark ? '#010606':'#fff' )};
    font-size:${({fontBig}) => (fontBig ? '20px' : '16px')};
    outline:none;
    border:none;
    cursor:pointer;
    display:flex;
    justify-content:center;
    align-items:center;
    transition:all 0.2s ease-in-out;
    border-radius:10px;
`;
export const ButtonDes = styled.button`
    background:transparent;
    border:2px solid #E8175D;
    cursor:pointer;
    display:flex;
    justify-content:center;
    align-items:center;
    transition:all 0.2s ease-in-out;
    border-radius:10px;
    padding: ${({big}) => (big ? '14px 48px' : '12px 30px' )};
    
    font-size:${({fontBig}) => (fontBig ? '20px' : '16px')};
    margin-left:2rem;
    @media screen and (max-width:600px){
        padding:1rem !important;
    } 
`;
export const ButtonLinkCV = styled.a`
    text-decoration:none;
    color: ${({dark}) => (dark ? '#010606':'#fff' )};
`;